export const convertHexToDecimal = (hexString) => {
    if (!hexString)
        return 0;
    return parseInt(String(hexString), 16);
};
export const convertSignedHexToDecimal = (hexValue) => {
    if (!hexValue)
        return 0;
    const hexString = String(hexValue);
    const bitLength = hexString.length * 4;
    let decimal = parseInt(hexString, 16);
    const maxPositiveValue = 1 << (bitLength - 1);
    const maxValue = 1 << bitLength;
    // Check if the highest bit is set for the given bit length
    if (decimal >= maxPositiveValue) {
        // Convert to negative value
        decimal -= maxValue;
    }
    return decimal;
};
